"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOM_WITH_PROPERTY_TYPE = void 0;
var RoomCount_1 = require("./RoomCount");
exports.ROOM_WITH_PROPERTY_TYPE = {
    hy: {
        apartment: (_a = {},
            _a[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-bnakaran-',
            _a[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-bnakaran-',
            _a[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-bnakaran-',
            _a[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-bnakaran-',
            _a),
        house: (_b = {},
            _b[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-sepakan-tun-',
            _b[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-sepakan-tun-',
            _b[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-sepakan-tun-',
            _b[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-sepakan-tun-',
            _b),
    },
    ru: {
        apartment: (_c = {},
            _c[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatnaya-kvartira-',
            _c[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatnaya-kvartira-',
            _c[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatnaya-kvartira-',
            _c[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatnaya-kvartira-',
            _c),
        house: (_d = {},
            _d[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatniy-chastniy-dom-',
            _d[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatniy-chastniy-dom-',
            _d[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatniy-chastniy-dom-',
            _d[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatniy-chastniy-dom-',
            _d),
    },
    en: {
        apartment: (_e = {},
            _e[RoomCount_1.ROOM_COUNT.ONE] = '1-room-apartment-',
            _e[RoomCount_1.ROOM_COUNT.TWO] = '2-room-apartment-',
            _e[RoomCount_1.ROOM_COUNT.TREE] = '3-room-apartment-',
            _e[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-apartment-',
            _e),
        house: (_f = {},
            _f[RoomCount_1.ROOM_COUNT.ONE] = '1-room-house-',
            _f[RoomCount_1.ROOM_COUNT.TWO] = '2-room-house-',
            _f[RoomCount_1.ROOM_COUNT.TREE] = '3-room-house-',
            _f[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-house-',
            _f),
    },
};
